export default function tabs(idPrefix = '') {
    return {
        activeTab: 0,
        tabCount: 0,
        idPrefix,

        select(index) {
            this.activeTab = index;
        },

        isActive(index) {
            return this.activeTab === index;
        },

        selectedAttr(index) {
            return String(this.activeTab === index);
        },

        tabIndex(index) {
            return this.activeTab === index ? 0 : -1;
        },

        tabId(index) {
            return this.idPrefix + 'tab-' + index;
        },

        panelId(index) {
            return this.idPrefix + 'tabpanel-' + index;
        },

        tabClass(index) {
            return this.activeTab === index
                ? 'border-primary text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border';
        },

        init() {
            this.tabCount = this.$refs.tablist
                ? this.$refs.tablist.querySelectorAll('[role="tab"]').length
                : 0;
        },

        handleKeydown(event) {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.activeTab = (this.activeTab + 1) % this.tabCount;
                this.focusActiveTab();
            } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.activeTab =
                    (this.activeTab - 1 + this.tabCount) % this.tabCount;
                this.focusActiveTab();
            } else if (event.key === 'Home') {
                event.preventDefault();
                this.activeTab = 0;
                this.focusActiveTab();
            } else if (event.key === 'End') {
                event.preventDefault();
                this.activeTab = this.tabCount - 1;
                this.focusActiveTab();
            }
        },

        focusActiveTab() {
            const tabs = this.$refs.tablist.querySelectorAll('[role="tab"]');
            if (tabs[this.activeTab]) {
                tabs[this.activeTab].focus();
            }
        },

        destroy() {},
    };
}
